import {combine, restore} from 'effector';

import {fetchInvoiceDetail} from 'api/documents';
import {rootDomain} from 'core/rootDomain';

import {InvoiceLine} from 'types/invoices';

import {$invoiceState, CreateInvoiceGate} from '../common';

const domain = rootDomain.createDomain('InvoiceBodyDomain');

export const setCombineByGtin = domain.createEvent<boolean>();
export const $combineByGtin = restore(setCombineByGtin, true).reset(CreateInvoiceGate.close);

export const setCurrentScannedGtin = domain.createEvent<string | null>();
export const $currentScannedGtin = restore(setCurrentScannedGtin, null).reset(
    CreateInvoiceGate.close,
);

export const setModalGroupByGtinSettings = domain.createEvent<{
    lineIndex: number;
    show: boolean;
    gtin?: string;
}>();
export const $modalGroupByGtinSettings = restore(setModalGroupByGtinSettings, {
    lineIndex: -1,
    show: false,
    gtin: undefined,
}).reset(CreateInvoiceGate.close);

export const $inlineInvoiceChargeModal = domain.createStore<{
    index?: number;
    show: boolean;
}>({
    index: undefined,
    show: false,
});

export const setInlineInvoiceChargeModal = domain.createEvent<{
    index?: number;
    show: boolean;
}>();

export const $inlineModalFormReadonly = domain.createStore<{
    index: number;
    show: boolean;
}>({
    index: -1,
    show: false,
});

export const setInlineModalFormReadonly = domain.createEvent<{
    index: number;
    show: boolean;
}>();

export const $modalDuplicateLinesModal = domain.createStore<{
    index?: number;
    show: boolean;
    initialLineData?: Partial<InvoiceLine>;
}>({
    show: false,
});

export const setModalDuplicateLinesModal = domain.createEvent<{
    index?: number;
    show: boolean;
    initialLineData?: Partial<InvoiceLine>;
}>();

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchInvoiceDetail,
});

export const commonData$ = domain.createStore<string | null>(null);

export const $everythingReady = combine($invoiceState, commonData$, (allDone, extraDone) => {
    if (allDone === 'new') {
        return true;
    }
    return allDone && extraDone;
}).reset(CreateInvoiceGate.close);

export const $commonDataState = combine({
    data: commonData$,
    isLoading: fetchDataFx.pending,
}).reset(CreateInvoiceGate.close);

$inlineInvoiceChargeModal.reset(CreateInvoiceGate.close);
$modalDuplicateLinesModal.reset(CreateInvoiceGate.close);
